import PropTypes from 'prop-types';
import UITooltipContent from 'UIComponents/tooltip/UITooltipContent';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'I18n... Remove this comment to see the full error message
import FormattedDuration from 'I18n/components/FormattedDuration';
import FormattedDateTime from 'I18n/components/FormattedDateTime';
import { SaveStates } from 'editor-components/EPConstants';
import { LegacyEPSaveLabel, TrellisEPSaveLabel } from 'editor-components/header/EPSaveLabel';
import { isLastSaveToday } from 'editor-components/utils/durationUtils';
import { useCallback } from 'react';
import { withNonTrellisComponent, withTrellisComponent } from '../hoc/withTrellisComponentHOCs';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
const useSaveLabelMessage = saveState => {
  return useCallback(({
    showLastSaved
  }) => {
    let message;
    switch (saveState) {
      case SaveStates.SAVING_CHANGES:
        message = 'epSaveLabel.saving';
        break;
      case SaveStates.AUTO_SAVED_CHANGES:
        {
          message = 'epSaveLabel.autoSaved';
          break;
        }
      case SaveStates.SAVED_CHANGES:
        {
          if (!showLastSaved) {
            message = 'epSaveLabel.saved';
          } else {
            message = 'epSaveLabel.save';
          }
          break;
        }
      case SaveStates.SAVE_FAILED:
        message = 'epSaveLabel.notSaved';
        break;
      default:
        message = 'epSaveLabel.save';
    }
    return message;
  }, [saveState]);
};
const EPSaveButton = ({
  iconColor,
  lastSave,
  onClick,
  renderTooltipContent,
  saveState,
  tooltipPlacement = 'bottom',
  tooltipUse = 'default',
  disabled,
  justifyLabel = 'end',
  statusIconPosition,
  CustomTooltip,
  isTrellisCompatibleComponent
}) => {
  const getMessage = useSaveLabelMessage(saveState);
  function getTooltipContent(now) {
    if (renderTooltipContent) {
      return renderTooltipContent(now);
    }
    let message;
    let lastSaveDate;
    let lastSaveDuration;
    if (lastSave) {
      if (isLastSaveToday({
        lastSave,
        now
      })) {
        message = 'epSaveLabel.savedAtToday';
      } else {
        message = 'epSaveLabel.savedAt';
      }
      lastSaveDate = /*#__PURE__*/_jsx(FormattedDateTime, {
        value: lastSave,
        format: "LL"
      });
      lastSaveDuration = /*#__PURE__*/_jsx(FormattedDuration, {
        to: lastSave,
        from: now,
        includeAffix: true
      });
      if (isTrellisCompatibleComponent) {
        return /*#__PURE__*/_jsx(Text, {
          textWrap: "nowrap",
          as: "span",
          color: "text-primary-on-fill-default",
          children: /*#__PURE__*/_jsx(FormattedReactMessage, {
            message: message,
            options: {
              lastSaveDate,
              lastSaveDuration
            }
          })
        });
      }
      return /*#__PURE__*/_jsx(UITooltipContent, {
        children: /*#__PURE__*/_jsx(FormattedReactMessage, {
          message: message,
          options: {
            lastSaveDate,
            lastSaveDuration
          }
          // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
          ,
          style: {
            whiteSpace: 'nowrap'
          }
        })
      });
    }
    return null;
  }
  if (isTrellisCompatibleComponent) {
    return /*#__PURE__*/_jsx(TrellisEPSaveLabel, {
      getMessage: getMessage,
      iconColor: iconColor
      // @ts-expect-error temporary. This _should_ be totally fine, but TS flattens the related union types into one that can't be distinguished via the `isTrellisCompatibleComponent` prop
      ,
      justifyLabel: justifyLabel,
      lastSave: lastSave,
      onClick: onClick,
      onDark: true,
      renderTooltipContent: getTooltipContent,
      saveState: saveState,
      tooltipPlacement: tooltipPlacement,
      tooltipUse: tooltipUse,
      disabled: disabled,
      statusIconPosition: statusIconPosition,
      CustomTooltip: CustomTooltip
    });
  }
  return /*#__PURE__*/_jsx(LegacyEPSaveLabel, {
    getMessage: getMessage,
    iconColor: iconColor
    // @ts-expect-error temporary. This _should_ be totally fine, but TS flattens the related union types into one that can't be distinguished via the `isTrellisCompatibleComponent` prop
    ,
    justifyLabel: justifyLabel,
    lastSave: lastSave,
    onClick: onClick,
    onDark: true,
    renderTooltipContent: getTooltipContent,
    saveState: saveState,
    tooltipPlacement: tooltipPlacement,
    tooltipUse: tooltipUse,
    disabled: disabled,
    statusIconPosition: statusIconPosition,
    CustomTooltip: CustomTooltip
  });
};
EPSaveButton.propTypes = {
  iconColor: PropTypes.string,
  lastSave: PropTypes.instanceOf(Date),
  onClick: PropTypes.func,
  renderTooltipContent: PropTypes.func,
  saveState: PropTypes.string.isRequired,
  tooltipPlacement: PropTypes.string,
  tooltipUse: PropTypes.string,
  disabled: PropTypes.bool
};

// @ts-expect-error prop types not playing nicely with the HOC
export const LegacyEPSaveButton = withNonTrellisComponent()(EPSaveButton);
// @ts-expect-error prop types not playing nicely with the HOC
export const TrellisEPSaveButton = withTrellisComponent()(EPSaveButton);
export default LegacyEPSaveButton;